import styled, { createGlobalStyle, css } from 'styled-components';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import { Close } from '@mui/icons-material';
import { animation } from 'utils';

export const GlobalStyle = createGlobalStyle`
  body {
    background: ${({ $background }) => `url(${$background}) no-repeat center center fixed`};
    background-size: cover;
  }
`;

export const CloseIcon = styled(Close)`
  cursor: pointer;
  font-size: 1.2em;
  margin-top: 0.2rem;
  margin-right: 0.3rem;
`;

export const FreshchatLoader = styled(CircularProgress)`
  position: absolute;
  color: white;
  top: 6px;
  right: 4px;
  z-index: 1;
`;

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  padding-bottom: 1rem;
`;

export const Image = styled.img`
  ${({ $isContact, $isShadow }) => css`
    ${$isShadow && 'filter: drop-shadow(5px 5px 5px #909090);'}
    @media (min-width: 550px) {
      ${$isContact && 'margin-left: 4.5rem;'}
    }
  `};
  margin-bottom: 0.5rem;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 1px;
  padding: 0 0.5rem;
  @media (max-width: 550px) {
    flex-direction: column;
    gap: 0.5rem;
    width: 85%;
  }
`;

export const ContactIcons = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 3rem;
  padding: 1.5rem 1rem;
  gap: 1rem;
  height: max-content;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  @media (max-width: 550px) {
    flex-direction: row;
    padding: 0.5rem 0;
    width: 100%;
    gap: 2rem;
  }
`;

export const Icon = styled.img`
  filter: drop-shadow(0px 1px 5px #a5a5a5);
  cursor: pointer;
  max-width: 50px;
  animation: ${animation.push} 0.7s ease;
  transition: 0.2s;
  &:hover {
    transform: scale(1.1);
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: wrap;
  background-color: white;
  border-radius: 1rem;
  padding: 2rem;
  max-width: 600px;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  gap: 1.5rem;
  @media (max-width: 550px) {
    gap: 1rem;
  }
`;

export const Title = styled.h1`
  margin: 0;
  padding: 1rem;
  font-weight: 500;
  text-align: center;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
`;

export const SucessMessage = styled.p`
  margin: 0;
  font-size: 1.5em;
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.01em;
  padding: 0 1rem;
`;

export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 2rem;
  @media (max-width: 550px) {
    align-items: stretch;
    flex-direction: column;
  }
`;
export const Field = styled.div`
  display: flex;
  align-items: ${({ $alignCenter }) => ($alignCenter ? 'center' : 'flex-end')};
  flex: 40%;
`;

export const Button = styled(MuiButton)`
  padding: 0.5rem 0;
`;

export const Redirecting = styled.div`
  font-size: 5em;
  color: #fff;
  text-shadow: #000 1px 2px 5px;
  margin-left: 5rem;
  font-weight: 500;
  &:after {
    content: '...';
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ${animation.dots} 1s infinite 0.3s;
    animation-fill-mode: forwards;
    width: 1.25em;
  }
`;
